import styled from 'styled-components';

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 60vh;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 1400px) {
    max-width: 95vw;
    margin: 0 8px;
    min-height: 60vh;
  }

  @media (max-width: 600px) {
    max-width: 98vw;
    min-height: 70vh;
  }
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.primary || '#293778'};
`;

export const ModalDescription = styled.p`
  margin: 4px 0 0 0;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors?.text_grey || '#6b7280'};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors?.text_grey || '#6b7280'};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors?.grey_200 || '#f3f4f6'};
    color: ${({ theme }) => theme.colors?.text || '#374151'};
  }
`;

export const ModalContent = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  background-color: white;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  background-color: white;
  position: sticky;
  bottom: 0;
  z-index: 1;
  border-top: 1px solid #e2e8f0;
  padding: 16px 24px;
`;

export const InvoiceHeader = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
`;

export const InvoiceInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const InvoiceDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
`;

export const TransactionsSection = styled.div`
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
`;

export const TransactionsHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #f8fafc;
`;

export const TransactionsTable = styled.div`
  overflow-x: auto;
`;
